'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccordionItemTitle = function AccordionItemTitle(props) {
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)("panel-heading", { "open": props.isActive || props.expandAll }), onClick: function onClick() {
        return props.handleClick(props.keyIndex);
      } },
    _react2.default.createElement(
      'div',
      { className: (0, _classnames2.default)("panel-title", { "collapsed": !props.isActive && !props.expandAll }), role: 'button' },
      props.children,
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'panel-indicator__icon-container pull-right' },
          !props.isActive || props.expandAll || !props.formMode ? _react2.default.createElement('span', { className: 'panel-indicator-icon glyphicon' }) : _react2.default.createElement(
            'span',
            { className: 'panel-indicator-label' },
            props.keyIndex + 1,
            '/',
            props.itemsCount
          )
        ),
        _react2.default.createElement('div', { className: 'panel-indicator__separator-top' }),
        _react2.default.createElement('div', { className: 'panel-indicator__separator-bottom' })
      )
    )
  );
};

AccordionItemTitle.propTypes = {
  isActive: _propTypes2.default.bool,
  keyIndex: _propTypes2.default.any,
  handleClick: _propTypes2.default.func,
  expandAll: _propTypes2.default.bool,
  itemsCount: _propTypes2.default.number,
  formMode: _propTypes2.default.bool
};

AccordionItemTitle.defaultProps = {
  isActive: false,
  expandAll: false
};

exports.default = AccordionItemTitle;